/*******************************************************************************
 * $Id: UserAgent.js 16544 2017-12-21 23:28:10Z dherold $
 *******************************************************************************/

/**
 * @ngdoc    object
 * @module   csm.ui.tools
 * @name     csm.ui.tools.type:UserAgent
 *
 * @description
 * Utility constant for determining common user agents.
 *******************************************************************************/

export const userAgent = {
  /**
   * @ngdoc    method
   * @name     isAndroid
   * @methodOf csm.ui.tools.type:UserAgent
   * @returns  {Boolean} Boolean indication the user is an android device
   */
  isAndroid: function () {
    return !!navigator.userAgent.match(/Android/g);
  },
  /**
   * @ngdoc    method
   * @name     isChrome
   * @methodOf csm.ui.tools.type:UserAgent
   * @returns  {Boolean} Boolean indication the user is chrome
   */
  isChrome: function () {
    return !!navigator.userAgent.match(/Chrome/g);
  },
  /**
   * @ngdoc    method
   * @name     isFF
   * @methodOf csm.ui.tools.type:UserAgent
   * @returns  {Boolean} Boolean indication the user is firefox
   */
  isFF: function () {
    return !!navigator.userAgent.match(/Firefox/g);
  },
  /**
   * @ngdoc    method
   * @name     isIE
   * @methodOf csm.ui.tools.type:UserAgent
   * @returns  {Boolean} Boolean indication the user is any internet explorer
   */
  isIE: function () {
    return (
      !!navigator.userAgent.match(/Trident/g) ||
      !!navigator.userAgent.match(/MSIE/g)
    );
  },
  /**
   * @ngdoc    method
   * @name     isIE9
   * @methodOf csm.ui.tools.type:UserAgent
   * @returns  {Boolean} Boolean indication the user is internet explorer 9
   */
  isIE9: function () {
    return !!navigator.appVersion.match(/MSIE 9/g);
  },
  /**
   * @ngdoc    method
   * @name     isIOSDevice
   * @methodOf csm.ui.tools.type:UserAgent
   * @returns  {Boolean} Boolean indication the user is an ios device
   */
  isIOSDevice: function () {
    return !!navigator.userAgent.match(/ipad|iphone/i);
  }
};
